//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from './../../components/Table/Table.vue'
import { convertTime } from './../../components/helpers.js'
import OrderAdmittancePerformerEdit from './OrderAdmittancePerformerEdit.vue'

export default {
  components: {
    Table,
    OrderAdmittancePerformerEdit
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    },
    performers: {
      type: Array,
      default () {
        return []
      }
    },
    isObservable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      performer: {},
      editIndex: -1,
      openedEdit: false,
      columns: [
        {
          name: 'fio',
          label: (this.isObservable ? 'Наблюдатель' : 'Исполнитель') + ' работ',
          align: 'left',
          field: 'fio'
        },
        {
          name: 'position',
          label: 'Должность ' + (this.isObservable ? 'наблюдателя' : 'исполнителя') + ' работ',
          align: 'left',
          field: 'position'
        },
        {
          name: 'organization',
          label: 'Организация',
          align: 'left',
          field: 'organization',
          display: this.isObservable
        },
        {
          name: 'qualifications',
          label: 'Квалификации и допуски',
          align: 'left',
          field: 'qualifications',
          format: this.formatQualifications,
          display: !this.isObservable
        },
        {
          name: 'instructorFio',
          label: 'Инструктор',
          align: 'left',
          field: 'instructorFio'
        },
        {
          name: 'instructorPosition',
          label: 'Должность инструктора',
          align: 'left',
          field: 'instructorPosition'
        },
        {
          name: 'instructageTime',
          label: 'Время инструктажа',
          align: 'left',
          field: 'instructageTime',
          format: convertTime
        }
      ]
    }
  },
  computed: {
    readonly: function () {
      return this.orderAdmittance.state === 'AD5' || this.orderAdmittance.state === 'AD6' || this.orderAdmittance.state === 'AD7'
    }
  },
  watch: {
    'orderAdmittance.givingEmployee.key': function () {
      if (this.orderAdmittance.givingEmployee.key) {
        if (this.orderAdmittance.seniorEmployee && this.orderAdmittance.seniorEmployee.key) {
          const seniorPerformer = this.performers.find(performer => performer.key === this.orderAdmittance.seniorEmployee.key)
          if (seniorPerformer) {
            seniorPerformer.instructorKey = this.orderAdmittance.givingEmployee.key
            seniorPerformer.instructorFio = this.orderAdmittance.givingEmployee.fio
            seniorPerformer.instructorPosition = this.orderAdmittance.givingEmployee.position
          }
        }
      }
    },
    'orderAdmittance.seniorEmployee.key': function () {
      if (this.orderAdmittance.seniorEmployee.key) {
        if (this.performers && this.performers.length) {
          this.performers.forEach((performer) => {
            if (performer.key !== this.orderAdmittance.seniorEmployee.key) {
              performer.instructorKey = this.orderAdmittance.seniorEmployee.key
              performer.instructorFio = this.orderAdmittance.seniorEmployee.fio
              performer.instructorPosition = this.orderAdmittance.seniorEmployee.position
            } else {
              if (this.orderAdmittance.givingEmployee.key) {
                performer.instructorKey = this.orderAdmittance.givingEmployee.key
                performer.instructorFio = this.orderAdmittance.givingEmployee.fio
                performer.instructorPosition = this.orderAdmittance.givingEmployee.position
              }
            }
          })
        }
      }
    },
    'orderAdmittance.startWorkTime': function () {
      if (this.orderAdmittance.startWorkTime && typeof this.orderAdmittance.startWorkTime === 'string') {
        if (this.performers && this.performers.length) {
          this.performers.forEach((performer) => {
            performer.instructageTime = this.orderAdmittance.startWorkTime
          })
        }
      }
    }
  },
  methods: {
    formatQualifications: function (qualifications) {
      if (qualifications) {
        return qualifications.join(', ')
      }
    },
    onAdd: function () {
      this.performer = {
        key: null,
        fio: null,
        position: null,
        qualifications: [],
        instructorKey: null,
        instructorFio: null,
        instructorPosition: null,
        instructageTime: null
      }
      if (this.isObservable) {
        this.$set(this.performer, 'organization', null)
      }
      if (this.orderAdmittance.startWorkTime) {
        this.performer.instructageTime = this.orderAdmittance.startWorkTime
      }
      this.openedEdit = true
    },
    onEdit: function (performer) {
      this.performer = JSON.parse(JSON.stringify(performer))
      this.editIndex = this.performers.findIndex(performer => performer.key === this.performer.key)
      this.openedEdit = true
    },
    onDelete: function (performer) {
      const index = this.performers.findIndex(p => p.key === performer.key)
      if (index !== -1) {
        this.performers.splice(index, 1)
      }
    },
    onSaveEdit: function (performer) {
      if (this.editIndex !== -1) {
        this.performers.splice(this.editIndex, 1, performer)
      } else {
        this.performers.push(performer)
      }
      this.onCloseEdit()
    },
    onCloseEdit: function (performer) {
      this.performer = {}
      this.editIndex = -1
      this.openedEdit = false
    },
    getTrStyle: function (row) {
      if (this.orderAdmittance.notValidPerformers && this.orderAdmittance.notValidPerformers.includes(row.key) && !this.isObservable) {
        return 'background-color: #ffcece !important;'
      }
    }
  }
}

